import { render, staticRenderFns } from "./SliceView.vue?vue&type=template&id=3791e077&scoped=true&"
import script from "./SliceView.vue?vue&type=script&lang=js&"
export * from "./SliceView.vue?vue&type=script&lang=js&"
import style0 from "./SliceView.vue?vue&type=style&index=0&id=3791e077&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3791e077",
  null
  
)

export default component.exports